import { createContext, useEffect, useContext } from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";

import withMapPanelWrapper from "./withMapPanelWrapper";
import MapPanelDesktop from "./MapPanelDesktop";
import MapPanelMobile from "./MapPanelMobile";
import { Desktop, NonDesktop } from "../../Utils/ResponsiveQueries";
import { MapWithSidebarLayoutContext } from "../MapWithSidebarLayout";
import { useMapContext } from "../MapContext";

import { showMapPanel, removeMapPanel } from "../../../reducers/map/panels";

export const MapPanelContext = createContext({});

const MapPanel = props => {
  const { mapSidebarContainer } = useContext(MapWithSidebarLayoutContext);

  const { mapKey } = useMapContext();
  const { id } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showMapPanel(mapKey, id));

    return () => dispatch(removeMapPanel(mapKey, id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ReactDOM.createPortal(
    <>
      <Desktop>
        <MapPanelDesktop {...props} />
      </Desktop>
      <NonDesktop>
        <MapPanelMobile {...props} />
      </NonDesktop>
    </>,
    mapSidebarContainer
  );
};

export default withMapPanelWrapper(MapPanel);
